<template>
  <HelloWorld />
</template>

<script>
import HelloWorld from '../components/Home';

export default {
  components: {
    HelloWorld
  }
};
</script>
